<!--
 * @Descripttion: 时间属性设置
 * @Author: zenghua.wang
 * @Date: 2021-12-06 16:12:01
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 11:06:21
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <el-collapse-item title="时间设置">
      <el-form-item label="时间格式">
        <el-select
          v-model="data.option.type"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in formatList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="自定义格式">
        <el-input v-model="data.option.formater" />
      </el-form-item> -->

      <!-- <el-form-item label="字体间距">
        <el-input-number
          v-model="data.option.split"
          :max="100"
        />
      </el-form-item> -->

      <el-form-item label="字体大小">
        <el-input-number
          clearable
          v-model="data.option.fontSize"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.color"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <el-form-item label="字体粗细">
        <el-select
          v-model="data.option.fontWeight"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in weightList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="对齐方式">
        <el-select
          v-model="data.option.textAlign"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in alignList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>
<script>
import {
  theme,
  predefineColors,
  component
} from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'

export default {
  name: 'config-datetime',
  components: {
    configBase,
    configAuth
  },
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      weightList: component.weightType,
      alignList: component.alignType,
      formatList: [
        {
          label: '日期',
          value: 'date'
        },
        {
          label: '日期时间',
          value: 'datetime'
        },
        {
          label: '时间',
          value: 'time'
        },
        {
          label: '年月',
          value: 'year-month'
        },
        {
          label: '月日',
          value: 'month-day'
        },
        {
          label: '星期',
          value: 'day'
        }
      ]
    }
  }
}
</script>

